/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoItemTransactionLogListItemTransactionLogData model module.
 * @module model/LogControllerDtoItemTransactionLogListItemTransactionLogData
 * @version 1.0
 */
class LogControllerDtoItemTransactionLogListItemTransactionLogData {
    /**
     * Constructs a new <code>LogControllerDtoItemTransactionLogListItemTransactionLogData</code>.
     * @alias module:model/LogControllerDtoItemTransactionLogListItemTransactionLogData
     */
    constructor() { 
        
        LogControllerDtoItemTransactionLogListItemTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoItemTransactionLogListItemTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoItemTransactionLogListItemTransactionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoItemTransactionLogListItemTransactionLogData} The populated <code>LogControllerDtoItemTransactionLogListItemTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoItemTransactionLogListItemTransactionLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('transactionType')) {
                obj['transactionType'] = ApiClient.convertToType(data['transactionType'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('beforeCount')) {
                obj['beforeCount'] = ApiClient.convertToType(data['beforeCount'], 'Number');
            }
            if (data.hasOwnProperty('afterCount')) {
                obj['afterCount'] = ApiClient.convertToType(data['afterCount'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoItemTransactionLogListItemTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoItemTransactionLogListItemTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['email'] = undefined;

/**
 * @member {Number} itemId
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemCount
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['itemCount'] = undefined;

/**
 * @member {Number} transactionType
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['transactionType'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} beforeCount
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['beforeCount'] = undefined;

/**
 * @member {Number} afterCount
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['afterCount'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoItemTransactionLogListItemTransactionLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoItemTransactionLogListItemTransactionLogData;

